import PageLayout from '@/components/feature/PageLayout';
import ResultsHero from '@/pages/results/components/ResultsHero';
import PlatformResults from '@/pages/results/components/PlatformResults';
import GrowthShowcase from '@/pages/results/components/GrowthShowcase';
import AdCabinetScreenshots from '@/pages/results/components/AdCabinetScreenshots';
import ResultsTimeline from '@/pages/results/components/ResultsTimeline';

export default function ResultsPage() {
  return (
    <PageLayout>
      <ResultsHero />
      <PlatformResults />
      <GrowthShowcase />
      <AdCabinetScreenshots />
      <ResultsTimeline />
    </PageLayout>
  );
}